import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { Button, Tabs, Tab, Typography, TextField, OutlinedInput, InputLabel, InputAdornment, FormControl, Hidden, Paper } from '@material-ui/core';
import clsx from 'clsx';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import GoogleLogo from '../../../Assets/images/google-logo.png';
import axios from 'axios';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles((theme) => ({
        leftBoxHiden: {
            height: '100vh',
            display: 'flex',
        },

        hiden: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },

        wrapper: {
            maxWidth: '552px',
            margin: 'auto',
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10),
        },

        cardContainer: {
            maxWidth: 345,
        },

        tabs: {
            marginBottom: theme.spacing(7),
        },

        typo: {
            marginBottom: theme.spacing(5),
        },

        googleIcon: {
            width: 40,
            background: 'white',
            borderRadius: '50%',
            marginRight: theme.spacing(2),
        },

        googleButton: {
            textTransform: 'capitalize',
            width: '100%',
            margin: 8,
            '&:hover': {
                backgroundColor: '#DD4B39',
                color: '#FFF'
            }
        },
        
        buttonContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: theme.spacing(4),
        },

        loginContainer: {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            margin: 'auto'
        },

        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            marginBottom: theme.spacing(2),
            width: '100%',
            margin: 8,
        },

        logInButton : {
            textTransform: 'capitalize',
            width: '100%',
            margin: 8,
            '&:hover': {
                backgroundColor: '#303F9F',
                color: '#FFF'
            }
            
        },

        loginButtonContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: theme.spacing(1),
        },

        signUpTypo: {
            margin: 8,
        },

        paper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#001524',
            height: 'inherit',
            width: '60vw',
        },
    
        paperTypo: {
            color: 'white',
            margin: 'auto',
        },

        link: {
            color: '#ffecd1',
            '&:hover': {
                color: '#ffecd1',
                textDecoration: 'none'
            }
        },

        loginLink: {
            color: 'black',
            '&:hover': {
                color: '#ffecd1',
                textDecoration: 'none'
            }
        }
    }));

const Login = () => {
    const classes = useStyles();

    // <--- START Tabs Function  ---> //
    // const [value, setValue] = useState(2);
    // const handleTabChange = (event, newValue) => {
    //     setValue(newValue);
    // }
    // // <--- END Tabs Function ---> //

    // <--- START Email and Password Input Function ---> //

    const [emailAndPassword, setEmailAndPassword] = useState({});
    console.log(emailAndPassword)

    const [passwordVisibility, setPasswordVisibility] = useState({showPassword: false});
    console.log(passwordVisibility.showPassword)

    const handleClickShowPassword = () => {
        setPasswordVisibility({ ...passwordVisibility, showPassword: !passwordVisibility.showPassword });
    };
    
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    // const handleSubmit = (e) => {


    //     });
        
    //     //return response.json(); 
    //     .then(res => {
    //      if (res.status === 200) {
    //         this.emailAndPassword.history.push('/');
    //         } else {
    //         const error = new Error(res.error);
    //         throw error;
                            
    //          }
    //         })
    //          .catch(err => {
    //          console.error('Error');
    //         alert('Please retry login process')
    //         });
    //     };
    // }
        
    const handleSubmit = (e) => {
        e.preventDefault();
        return axios.post('/api/auth/login/user', {
    
            method: 'POST',
            body: JSON.stringify({emailAndPassword}),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })
                .then(res => {
                if (res.status === 200) {
                    this.emailAndPassword.history.push('/');
                } else {
                    const error = new Error(res.error);
                    throw error;
                    
                }
            })
                .catch(err => {
                    console.error('Error');
                    alert('Please retry login process')
                });
            }

    // <--- END Email and Password Input Function ---> //

    return (
        <>
        <div className={classes.leftBoxHiden}>
            <Hidden mdDown>
                <Paper square className={classes.paper}>
                    <Typography className={classes.paperTypo} variant='h1' align='center'>
                        <Link className={classes.link} to={'/'}>Transporex</Link>
                    </Typography>
                </Paper>
            </Hidden>
            <div className={classes.wrapper}>
                <Tabs
                    className={classes.tabs}
                    // value={value}
                    indicatorColor="primary"
                    textColor="primary"
                    // onChange={handleTabChange}
                    aria-label="disabled tabs example"
                    centered
                >
                    <Link to='/'><Tab label={<ArrowBackIcon/>} /></Link>
                    <Link to='/login'><Tab label="Login" /></Link>
                    <Link to='/signup'><Tab label="Register" /></Link>
                </Tabs>
                <Typography className={classes.typo} align='center' variant='h4' gutterBottom>We're glad to see you again!</Typography>
                <div className={classes.buttonContainer}>
                    <Button variant='contained' disableRipple='true' size="medium" className={classes.googleButton}>
                        <img src={GoogleLogo} alt="google" className={classes.googleIcon} />
                        &nbsp;Sign in with Google
                    </Button>
                </div>
                <Typography className={classes.typo} align='center' variant='body1'>or login with email address</Typography>
                
                <div className={classes.loginContainer}>
                    <TextField
                        className={classes.textField}
                        id="Enter your Email address here"
                        label="Email Address"
                        value={emailAndPassword.email}
                        placeholder="example@transporex.com"
                        required
                        margin="normal"
                        variant="outlined"
                        onChange={(e) => setEmailAndPassword({ ...emailAndPassword, email: e.target.value })}
                    />

                    <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined">
                        <InputLabel required htmlFor="user-password">Password</InputLabel>
                            <OutlinedInput
                                id="user-password"
                                type={passwordVisibility.showPassword ? 'text' : 'password'}
                                value={emailAndPassword.password}
                                onChange={(e) => setEmailAndPassword({ ...emailAndPassword, password: e.target.value })}
                                endAdornment={
                                <InputAdornment  position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {passwordVisibility.showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                        }
                        labelWidth={90}
                        />
                    </FormControl>
                </div>

                <div className={classes.loginButtonContainer}>
                    <Button
                    variant='contained' disableRipple='true' size="large" className={classes.logInButton}
                    onClick={({handleSubmit}) => console.log(emailAndPassword)}
                    >
                        <Link to={'/dashboard'} className={classes.loginLink}>
                            &nbsp;Log In
                        </Link>
                    </Button>
                </div>
                <Typography className={classes.signUpTypo} gutterBottom>Don't have an account? <Link to='signup'>Sign up</Link></Typography>
            </div>
        </div>
        </>
    )
}

export default Login;
